module.exports = __webpack_public_path__ + "img/com21.e36d1cb0.png";